import { render, staticRenderFns } from "./getOrderInfo.vue?vue&type=template&id=62d1258c&scoped=true&"
import script from "./getOrderInfo.vue?vue&type=script&lang=js&"
export * from "./getOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./getOrderInfo.vue?vue&type=style&index=0&id=62d1258c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d1258c",
  null
  
)

component.options.__file = "getOrderInfo.vue"
export default component.exports